import { gql } from '@apollo/client';

export const HANDLE_PICKUP_FAILED = gql`
  mutation HandlePickupFailed($input: HandlePickupFailedInput!) {
    handlePickupFailed(input: $input)
  }
`;
export interface HandlePickupFailedInput {
  appointmentId: string;
  taskId: string;
  failedReason: string;
  exceptionPhotosS3KeysJson: string[];
  actualPickupDate: string,
  actualPickupTimeEnd: string;
  cooperationWarehouseId?: string;
  // 揽收失败时刻司机 GPS（动作时刻取位，取不到时留空，不阻断提交）
  latitude?: number;
  longitude?: number;
}
export interface HandlePickupFailedResponse {
  handlePickupFailed: boolean;
}
